function* passwordGenerator() {
  const symbols =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$".split(
      "",
    );
  for (let i = 1; i <= 16; i++)
    yield symbols[Math.floor(Math.random() * symbols.length)];
}

export const generatePassword = () => [...passwordGenerator()].join("");
